import clsx from 'clsx';
import React, { useState } from 'react';

import { Avatar } from '../../../../common/Avatar';
import { Spinner } from '../../../../components/Spinner';
import { useTeamMembers } from '../../../../hooks/useTeamMembers';
import { TeamMemberSelectorProps } from '../../types/teamMember';

export function TeamMemberSelector({
  selectedMemberId,
  onMemberSelect,
  className,
}: TeamMemberSelectorProps): JSX.Element {
  const { data: teamMembers, isLoading } = useTeamMembers();
  const [hoveredMemberId, setHoveredMemberId] = useState<string | null>(null);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div className={clsx('flex -space-x-1', className)}>
      {teamMembers?.map((member) => (
        <div
          key={member.id}
          className="relative"
          onMouseEnter={() => setHoveredMemberId(member.id)}
          onMouseLeave={() => setHoveredMemberId(null)}
        >
          <button
            type="button"
            onClick={() => onMemberSelect(member.id)}
            className={clsx(
              'relative inline-block rounded-full ring-2 transition-all',
              selectedMemberId === member.id
                ? 'ring-primary z-10 scale-110'
                : 'ring-white hover:z-10 hover:ring-gray-200',
            )}
          >
            <Avatar
              src={member.avatarUrl}
              name={`${member.firstName} ${member.lastName}`}
              size="md"
            />
          </button>
          {hoveredMemberId === member.id && (
            <div className="absolute z-20 px-4 py-2 text-sm bg-gray-900 text-white rounded-md shadow-lg -top-12 left-1/2 transform -translate-x-1/2 min-w-[120px] whitespace-nowrap after:content-[''] after:absolute after:left-1/2 after:-bottom-2 after:-translate-x-1/2 after:border-8 after:border-transparent after:border-t-gray-900 after:border-l-gray-900 after:rotate-45 after:bg-gray-900 after:w-4 after:h-4">
              {`${member.firstName} ${member.lastName}`}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
